module.exports = __webpack_public_path__ + "static/media/intro.41c8fa49.md";


//////////////////
// WEBPACK FOOTER
// ./src/intro.md
// module id = 470
// module chunks = 0